<script>

</script>

<section id="contato">
    <div class="contact">
        <div class="contact__cards">

            <div class="contact_cardContainer">
                <div class="contact_card">
                    <div>
                        <div class="helper">
                              Contato
                          </div>
                    </div>
                </div>
            </div>

            <div class="email_cardContainer">
                <div class="chat-bubble transparent email_card">
                    <div>
                        <div class="chat-bubble-text">
                            contato@vlgiasset.com.br
                        </div>
                        <div class="chat-bubble-triangle"></div>
                    </div>
                </div>
            </div>

            <div class="phone_cardContainer">
                <div class="chat-bubble transparent phone_card">
                    <div>
                        <div class="chat-bubble-text">
                            +55 61 99808-4500
                        </div>
                        <div class="chat-bubble-triangle"></div>
                    </div>
                </div>
            </div>

            <div class="text_cardContainer">
                <div class="chat-bubble transparent text_card">
                    <div>
                        <div class="chat-bubble-text">
                            Centro Empresarial Parque Brasília , SIG Quadra 1, Lote 985/1055 Sala 223/224 , 70610-410 Brasília - DF
                        </div>
                        <div class="chat-bubble-triangle"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="certifications">
            <img src="./Images/Gestao-de-Patrimonio-Permanente-03.jpg" alt="Selo AMBIMA: Gestão de Patrimônio">
            <img src="./Images/Gestao-de-Recursos-Permanente-03.jpg" alt="Selo AMBIMA: Gestão dse Recursos">
        </div>

        <div class="btn-container">
            <a target="_blank" href="#/politicas-de-privacidade">Políticas de Privacidade</a>
        </div>

    </div>

</section>



<style lang="scss">
@use "../styles/variables" as v;
@use "../styles/chatBubble" as cb;

.contact{
    @media only screen and (min-width: 0) {
        --card-padding: 6em 1em;
        --card-mg-right: 0;
        --bg-position: 0 0;
        --certifications-flex-flow: column;
    }

    @media only screen and (min-width: v.$tablet-devices) {
        --card-padding: 6em 4em;
        --card-mg-right: 50%;
        --bg-position: 80% 0;
        --certifications-flex-flow: row;
    }

    @media only screen and (min-width: v.$md-desktop-devices) {
        .contact {
            &__cards {
                position: absolute;
                top: 30%;
                left: 10%;
                transform: translateY(-10%);
                padding: 0;
                margin-right: 0;
            }
        }
    }

    position: relative;
    background-image: url('../Images/contact_backover.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 100vh;
    min-height: 800px;
    overflow: hidden;
    background-position: var(--bg-position);

    img {
        display: none;
    }

    &__cards{
        padding: var(--card-padding);
        padding-bottom: 0;
        margin-right: var(--card-mg-right);

        .contact_card{
            border: 2px solid white;
            border-radius: 30px;
            color: white;
        }

        .contact_cardContainer{
            width: 21rem;
            max-width: 90%;
            margin-left: auto;
        }

        .email_cardContainer{
            width: fit-content;
            max-width: 90%;
            margin-left: auto;
            padding-top: 2.5em;
        }

        .phone_cardContainer{
            width: fit-content;
            max-width: 90%;
            margin-left: auto;
            padding-top: 2.5em;
        }

        .text_cardContainer{
            width: 17em;
            max-width: 90%;
            margin-left: auto;
            padding-top: 2.5em;

        }

        .contact_card{
            padding: 0.5em 1em;
            font-size: 1.714rem;
            text-transform: uppercase;
            text-align: center;
        }

        .text_card{
            text-align: center;
        }
    }

    .btn-container {
        position: absolute;
        bottom: 2%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: fit-content;

        a {
            color: white;
            font-size: 1.5rem;
        }

        a:hover {
            color: v.$clr-purple;
        }
    }

    .certifications {
        position: absolute;
        display: flex;
        flex-direction: var(--certifications-flex-flow);
        bottom: 7rem;
        right: 3.75rem;
        gap: 1.3rem;

        img {
            width: 10.625rem;
            height: auto;
            border-radius: 0.625rem;
            display: block;
        }
    }
}
</style>
